<template lang="pug">
.ui.container
  h1.ui.header {{$t('client_stats.header')}}
    .sub.header {{$t('client_stats.subheader')}}

  p(v-if="error_msg") {{$t('client_stats.error', {error: error_msg})}}

  .ui.stackable.grid
    .row
      .column.eight.wide
        h2.ui.header(v-html="$t('client_stats.by_status.header_html', {total: total_members})")

        pie-chart(
          :data="status_stats.stats"
        )

      .column.eight.wide
        h2.ui.header(v-html="$t('client_stats.by_age.header_html', {avg: avg_age})")

        column-chart(
          :data="age_stats.stats"
          :label="$t('client_stats.by_age.label')"
          :xtitle="$t('client_stats.by_age.xtitle')"
          :ytitle="$t('client_stats.by_age.ytitle')"
        )

        p.text-right.secondary(v-if="(age_stats.invalid.length)")
          | {{ $t('client_stats.no_data') }}
          | {{ invalids(age_stats) }}


    .row
      .column.sixteen.wide
        h2.ui.header {{$t('client_stats.by_rec.header')}}

        area-chart(
          :data="recipiert_stats.stats"
          :label="$t('client_stats.by_rec.label')"
          :xtitle="$t('client_stats.by_rec.xtitle')"
          :ytitle="$t('client_stats.by_rec.ytitle')"
        )

        p.text-right.secondary(v-if="(recipiert_stats.invalid.length)")
          | {{ $t('client_stats.no_data') }}
          | {{ invalids(recipiert_stats) }}


    .row
      .column.sixteen.wide
        h2.ui.header {{$t('client_stats.origin_clients.header')}}
          a(:href="ersband_url")
            sui-icon(name="suus-hit-down")

        pie-chart(
          :data="origin_clients.stats"
          legend="right"
      )

    .row
      .column.sixteen.wide
        h2.ui.header {{$t('client_stats.clubs_of_members.header')}}
          a(:href="clubs_url")
            sui-icon(name="suus-hit-down")

        pie-chart(
          :data="clubs_of_members.stats"
          legend="right"
      )

    .row
      .column.eight.wide
        h2.ui.header {{$t('client_stats.by_usage.header')}}

        pie-chart(
          :data="usage_stats.stats"
        )

        p.text-right.secondary(v-if="(usage_stats.invalid.length)")
          | {{ $t('client_stats.no_data') }}
          | {{ invalids(usage_stats) }}


      .column.eight.wide
        h2.ui.header {{$t('client_stats.by_pickup.header')}}

        area-chart(
          :data="pickup_stats.stats"
          :label="$t('client_stats.by_pickup.label')"
        )

        p.text-right.secondary(v-if="(pickup_stats.invalid.length)")
          | {{ $t('client_stats.no_data') }}
          | {{ invalids(pickup_stats) }}


    .row
      .column.eight.wide
        h2.ui.header(v-tooltip="$t('client_stats.by_summary_freq.tooltip')") {{$t('client_stats.by_summary_freq.header', {open_rate: two_week_open_rate})}}

        pie-chart(
          :data="summary_freq_stats.stats"
          legend="bottom"
        )


      .column.eight.wide
        h2.ui.header {{$t('client_stats.by_meantime.header')}}

        pie-chart(
          :data="login_by_meantime.stats"
          legend="bottom"
      )
</template>

<script>
import Vue from "vue"
export default Vue.extend({
  name: "ClientStats",
  props: [
    "client_id",
    "system_name",
    "total_members",
    "avg_age",
    "two_week_open_rate",
  ],

  data() {
    return {
      error_msg: "",
      status_stats: { stats: null, invalid: [] },
      age_stats: { stats: null, invalid: [] },
      recipiert_stats: { stats: null, invalid: [] },
      usage_stats: { stats: null, invalid: [] },
      pickup_stats: { stats: null, invalid: [] },
      summary_freq_stats: { stats: null, invalid: [] },
      login_by_meantime: { stats: null, invalid: [] },
      origin_clients: { stats: null, invalid: [] },
      clubs_of_members: { stats: null, invalid: [] },
    }
  },

  computed: {
    ersband_url() {
      return `/api/v1/stats/origin_clients.csv?client_id=${this.client_id}`
    },

    clubs_url() {
      return `/api/v1/stats/clubs_of_members.csv?client_id=${this.client_id}`
    },
  },

  created() {
    this.loadStatusStats()
    this.loadAgeStats()
    this.loadRecipiertStats()
    this.loadUsageStats()
    this.loadPickupStats()
    this.loadSummaryFreqStats()
    this.loadLoginByMeantimeStats()
    this.loadOriginClientsStats()
    this.loadClubsOfMembersStats()
  },

  methods: {
    invalids(data) {
      if (data && "invalid" in data) {
        return data.invalid.map((m) => m.name).join(", ")
      } else {
        return ""
      }
    },

    loadStatusStats() {
      let url = `/api/v1/stats/status?client_id=${this.client_id}`
      fetch(url, {
        method: "GET",
        credentials: "same-origin",
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          this.status_stats = data
        })
        .catch((err) => {
          this.error = err.toString()
        })
    },

    loadAgeStats() {
      let url = `/api/v1/stats/age?client_id=${this.client_id}`
      fetch(url, {
        method: "GET",
        credentials: "same-origin",
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          this.age_stats = data
        })
        .catch((err) => {
          this.error = err.toString()
        })
    },

    loadLoginByMeantimeStats() {
      let url = `/api/v1/stats/logins/by_meantime?client_id=${this.client_id}`
      fetch(url, {
        method: "GET",
        credentials: "same-origin",
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          this.login_by_meantime = this.labelData(
            "clients.stats.login_by_meantime.label",
            data
          )
        })
        .catch((err) => {
          this.error = err.toString()
        })
    },

    loadOriginClientsStats() {
      let url = `/api/v1/stats/origin_clients?client_id=${this.client_id}`
      fetch(url, {
        method: "GET",
        credentials: "same-origin",
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          data["stats"] = this.sumLastKeys(data["stats"])
          this.origin_clients = data
        })
        .catch((err) => {
          this.error = err.toString()
        })
    },

    loadClubsOfMembersStats() {
      let url = `/api/v1/stats/clubs_of_members?client_id=${this.client_id}`
      fetch(url, {
        method: "GET",
        credentials: "same-origin",
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          data["stats"] = this.sumLastKeys(data["stats"])
          this.clubs_of_members = data
        })
        .catch((err) => {
          this.error = err.toString()
        })
    },

    loadRecipiertStats() {
      let url = `/api/v1/stats/recipiert?client_id=${this.client_id}`
      fetch(url, {
        method: "GET",
        credentials: "same-origin",
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          this.recipiert_stats = data
        })
        .catch((err) => {
          this.error = err.toString()
        })
    },

    loadSummaryFreqStats() {
      let url = `/api/v1/stats/summary/freq?client_id=${this.client_id}`
      fetch(url, {
        method: "GET",
        credentials: "same-origin",
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          this.summary_freq_stats = this.labelData(
            "clients.stats.summary_freq.label",
            data
          )
        })
        .catch((err) => {
          this.error = err.toString()
        })
    },

    loadUsageStats() {
      let url = `/api/v1/stats/usage?client_id=${this.client_id}`
      fetch(url, {
        method: "GET",
        credentials: "same-origin",
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          this.usage_stats = this.labelData(
            "clients.stats.usage_stats.label",
            data
          )
        })
        .catch((err) => {
          this.error = err.toString()
        })
    },

    loadPickupStats() {
      let url = `/api/v1/stats/pickup?client_id=${this.client_id}`
      fetch(url, {
        method: "GET",
        credentials: "same-origin",
      })
        .then((res) => {
          return res.json()
        })
        .then((data) => {
          this.pickup_stats = data
        })
        .catch((err) => {
          this.error = err.toString()
        })
    },

    labelData(locale, data) {
      let stats = {}
      for (let [k, v] of Object.entries(data.stats)) {
        let label = this.$t(`${locale}_${k}`)
        stats = { ...stats, [label]: v }
      }
      return { stats: stats, invalid: [] }
    },

    sumLastKeys(data) {
      let lastKeys = Object.keys(data)
      lastKeys = lastKeys.slice(25, lastKeys.length)
      let others = 0

      lastKeys.forEach((lastKey) => {
        others += data[lastKey]
        delete data[lastKey]
      })
      if (others != 0) {
        data["weitere"] = others
      }
      return data
    },
  },
})
</script>

<style scoped></style>
